import { render, staticRenderFns } from "./DeleteSub.vue?vue&type=template&id=1aa7dcfc&scoped=true&"
import script from "./DeleteSub.vue?vue&type=script&lang=ts&"
export * from "./DeleteSub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7dcfc",
  null
  
)

export default component.exports